
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as faq_45VpaYSrd7nyWNucHnbXTUD3hPsNYhAZVmRNTe0Dty1AMeta } from "/codebuild/output/src3388520292/src/src/pages/faq.vue?macro=true";
import { default as menuVO4kWW_45H74ILe6DYwMF1fCq63ZSjuM5vofmx6m_dyj4Meta } from "/codebuild/output/src3388520292/src/src/pages/menu.vue?macro=true";
import { default as indexASwwtZNwnbduQYJkkm118xTyxhMdemTHDNRc4ju4DssMeta } from "/codebuild/output/src3388520292/src/src/pages/index.vue?macro=true";
import { default as contactLnDsns0hQ5w9SrOi9gMpnRypc8NknbkODINj6rRgoZ0Meta } from "/codebuild/output/src3388520292/src/src/pages/contact.vue?macro=true";
import { default as tutorialCOLYWNZpAdkb4jPCG3FnxbbNz7wT8NJq8VSnA32npK0Meta } from "/codebuild/output/src3388520292/src/src/pages/tutorial.vue?macro=true";
import { default as agreementBC2Tfcuf40Xw1n5rSCCrUfxfKLmCpaCGEGnW1_452GAaMMeta } from "/codebuild/output/src3388520292/src/src/pages/agreement.vue?macro=true";
import { default as about_45passjkaP2Kucl8c57BmbhKh8S08TakYQy66H4ZbteoHeATUMeta } from "/codebuild/output/src3388520292/src/src/pages/about-pass.vue?macro=true";
import { default as indexnLC8wN1lIkeFGuD3f_3rDJ_v7TifmVG1B4bq96elkEwMeta } from "/codebuild/output/src3388520292/src/src/pages/card/index.vue?macro=true";
import { default as _91id_93vvYFpYG8UteMTsyViw59nV6AXfVRJt5902O_45ZRp5hXkMeta } from "/codebuild/output/src3388520292/src/src/pages/coupon/[id].vue?macro=true";
import { default as maintenance91mkfCAHSJFZxikbJMcXr_45Hycglxld0gTND9s9lxrL4Meta } from "/codebuild/output/src3388520292/src/src/pages/maintenance.vue?macro=true";
import { default as _91id_93WzG8pNle9Z68SmyjbQ_45Nno_M6S8U5Wj_6RfGTX45EkMMeta } from "/codebuild/output/src3388520292/src/src/pages/notice/[id].vue?macro=true";
import { default as indexEqAzTadGLAOykUOoL2lvoOeYk3hfo6TAsoD0JaFBnIIMeta } from "/codebuild/output/src3388520292/src/src/pages/coupon/index.vue?macro=true";
import { default as indexoghsHsqYPDpDw1k6IWmuSq6LggOQL_2goQQad8wUK6kMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/index.vue?macro=true";
import { default as indexN_45P3OxHUBkCRd65k6IOqYrcGVfjo43XzC5gmBQjZ_45lUMeta } from "/codebuild/output/src3388520292/src/src/pages/notice/index.vue?macro=true";
import { default as _91id_93dNDkBh90N19KK2EZ8FnS_wkb5J9JjHCLIf8X_45uYDEHkMeta } from "/codebuild/output/src3388520292/src/src/pages/parking/[id].vue?macro=true";
import { default as indexkdvOK3a0wPXhx3ajFJLcP7nXvuZbT0j7afhsCevZlFcMeta } from "/codebuild/output/src3388520292/src/src/pages/history/index.vue?macro=true";
import { default as indexOm6Mn16HnRaUsY1diE94fLmhm0K7_onUDbFDO0thNx8Meta } from "/codebuild/output/src3388520292/src/src/pages/monthly/index.vue?macro=true";
import { default as index1FS1d7DOrpADJbHpA1ANTL8vQD7WpkBqSN7LO5IlQO4Meta } from "/codebuild/output/src3388520292/src/src/pages/sign-in/index.vue?macro=true";
import { default as indexWf9KTrLp_45qQdvz8yz9o4xythdug1hKUz9a3vkt7sGbsMeta } from "/codebuild/output/src3388520292/src/src/pages/sign-up/index.vue?macro=true";
import { default as about_45yumenavi0pocC0Afem9xwYC5hmBedb9FBIHoaEiQlWVpXo5gjqsMeta } from "/codebuild/output/src3388520292/src/src/pages/about-yumenavi.vue?macro=true";
import { default as editJu8aVgnuxRD0E1weUlljh8T5WnMjXxfSRbgnNNiIFxIMeta } from "/codebuild/output/src3388520292/src/src/pages/card/[id]/edit.vue?macro=true";
import { default as pass_45agreementbefEtwDyJAbFsb6SEXMBbKUFUboNDkzc_45o_45_45Rv4fnPQMeta } from "/codebuild/output/src3388520292/src/src/pages/pass-agreement.vue?macro=true";
import { default as indexYDA6AShnLBqWuRL5FpU6sF62bcFtPBRLkXBSzWdx3CQMeta } from "/codebuild/output/src3388520292/src/src/pages/card/[id]/index.vue?macro=true";
import { default as confirm_453dCMOMx_BcXGmXloGww4zPnItasR1KRMXTaqFHHO9tZucMeta } from "/codebuild/output/src3388520292/src/src/pages/card/confirm-3d.vue?macro=true";
import { default as confirmltfa_45_45rkdLJNhN0AUzpm1ZfuhXqtHtVixzn73_45d7nggMeta } from "/codebuild/output/src3388520292/src/src/pages/card/[id]/confirm.vue?macro=true";
import { default as indexC9jnHuejFXED3AMLSc2_45EpknMIwEORzHhSuvkIn7tooMeta } from "/codebuild/output/src3388520292/src/src/pages/card/create/index.vue?macro=true";
import { default as indexfgbfiePn2JAe3yFs0z5nmcgIUjuxGnMttOkNXOyLKc4Meta } from "/codebuild/output/src3388520292/src/src/pages/mypage/pass/index.vue?macro=true";
import { default as confirmBSU4mYRpvN51iNeRD5Nu4efS4MIwywUPxR_45tqNdXFowMeta } from "/codebuild/output/src3388520292/src/src/pages/membership/confirm.vue?macro=true";
import { default as confirmVVrhmweNkKg_sLaschsqYiIeMsz5SeuvWG1ClpGpbTMMeta } from "/codebuild/output/src3388520292/src/src/pages/card/create/confirm.vue?macro=true";
import { default as completeumHSCjDNdraqdj2mfh1kkqZjp_45nEhAmO_45q1_htRjyxkMeta } from "/codebuild/output/src3388520292/src/src/pages/membership/complete.vue?macro=true";
import { default as registerrNQVnQywXaIBLshE0CD6FHALJjsz7x6dyu0HREY233AMeta } from "/codebuild/output/src3388520292/src/src/pages/membership/register.vue?macro=true";
import { default as _91id_93E_453I06t_45S6WpgXKHQqeO8g2r_FEgN5z5NWTJy7a3I50Meta } from "/codebuild/output/src3388520292/src/src/pages/monthly/notice/[id].vue?macro=true";
import { default as confirmSEmJnx42X4RHs5IwH3vJ1pT7V4ZdjirYVG6o5cKC4boMeta } from "/codebuild/output/src3388520292/src/src/pages/contact-form/confirm.vue?macro=true";
import { default as _91id_93V3VHf_45HY8pZip3gHbqWz7gkONuNVNaAe8GSB5_R2cOYMeta } from "/codebuild/output/src3388520292/src/src/pages/history/receipt/[id].vue?macro=true";
import { default as indexQ3sYIEwfs9AKwkr2cAZbee0y8Hjt6uuFQp9_XiXCgg8Meta } from "/codebuild/output/src3388520292/src/src/pages/monthly/notice/index.vue?macro=true";
import { default as confirm_45codeiC9zsqSQbABujBotG7DJqF1X4D4bx8uUK2bnDEVP_45ZAMeta } from "/codebuild/output/src3388520292/src/src/pages/sign-in/confirm-code.vue?macro=true";
import { default as confirm_45coderVcn_FkAOQTgbqDUUNFenPI4bfOyb1d_fZzH5nyn9Z0Meta } from "/codebuild/output/src3388520292/src/src/pages/sign-up/confirm-code.vue?macro=true";
import { default as completeyKc39F9T4wpIddYJFjugY9AQaffe52VGF2bnV6ZOLLwMeta } from "/codebuild/output/src3388520292/src/src/pages/contact-form/complete.vue?macro=true";
import { default as registerVOaXTBWzpPPXjJKCxXL3myyF4ciLDCub8N9t9SewWEMMeta } from "/codebuild/output/src3388520292/src/src/pages/contact-form/register.vue?macro=true";
import { default as completesYuO9qOBEsEywHeUusUnZ6xXgmEVqweRYAJt5RqeC2QMeta } from "/codebuild/output/src3388520292/src/src/pages/monthly/cancel/complete.vue?macro=true";
import { default as index9pUDoR1P_SpHS8ZuqosdoRy9opgEuJDmBXGm3nFvRzgMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/index.vue?macro=true";
import { default as confirmFXiXgAVlip_45zHQeubdCF7h6Tg4SAWBSAp_qv1gfScYAMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/sign-out/confirm.vue?macro=true";
import { default as completeP5SZVWeQyQME_45gVTDVb1ahAdATTCYN0eHJngiSKP_45MEMeta } from "/codebuild/output/src3388520292/src/src/pages/reset-password/complete.vue?macro=true";
import { default as indexRdJjkAz00T85fIu_45PsgsHW_SEt3oxEDwDeY9aoHBu88Meta } from "/codebuild/output/src3388520292/src/src/pages/mypage/integration/index.vue?macro=true";
import { default as _91id_93EgQfaJigaFUEQl_45tw1Hy4D6bLMh_qUNXBGHUROukJh0Meta } from "/codebuild/output/src3388520292/src/src/pages/mypage/pass/receipt/[id].vue?macro=true";
import { default as complete3v_dZnU0BYQjporp56z1v2hdBVQFArQeoYiLVInCGtIMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/sign-out/complete.vue?macro=true";
import { default as edit_45card_45aliasVnsrFyAoTw9dNG_ZmeoqEsW8Zuee6cO0sCP4oIL_vbwMeta } from "/codebuild/output/src3388520292/src/src/pages/card/[id]/edit-card-alias.vue?macro=true";
import { default as samplehh_45rLbebG_wNhh6ZQWBbnXpX4PvnU3_45VW6_9WtiV8IwMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/integration/sample.vue?macro=true";
import { default as send_45emailOEgIVM5CttP0ZgLYQ5IIS9mnnZ20Ur0paizo54D_NXkMeta } from "/codebuild/output/src3388520292/src/src/pages/reset-password/send-email.vue?macro=true";
import { default as confirm7xOUvSy_45tRNLhSDpQJLjW3Of1ZWiw1M4iKLI6ZOWdlcMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/unsubscribe/confirm.vue?macro=true";
import { default as consent4tO6fHJeXdlE89IxbdgzjT1Ghik9RdXRQuI0h_45lo7HAMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/unsubscribe/consent.vue?macro=true";
import { default as confirmwHGEbImiw5vYfS_45OpMvryaDDYSP_5J32f0gdtpGqUo0Meta } from "/codebuild/output/src3388520292/src/src/pages/membership/yumenavi/confirm.vue?macro=true";
import { default as duedateRFYGleUCBGYMrjf9iG63e8Sysy1llBcBnP5vegPG8D8Meta } from "/codebuild/output/src3388520292/src/src/pages/monthly/application/duedate.vue?macro=true";
import { default as completef790eROUG81Q6vlo3tZE_45O_Rx_K7qpgiEfBfYgjJ_45UwMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/unsubscribe/complete.vue?macro=true";
import { default as confirm_45codeDCRSC2xa6nZM6flUckp2JlXyQZUyn2KoDUSbqjcFpM8Meta } from "/codebuild/output/src3388520292/src/src/pages/reset-password/confirm-code.vue?macro=true";
import { default as new_45password8jPivJCXqB1Z9BgTH8Jzv8rrAMLnLWZpw6ciofJyoQUMeta } from "/codebuild/output/src3388520292/src/src/pages/reset-password/new-password.vue?macro=true";
import { default as confirm_45card_45aliasObHGVOvvW8Ix_45FuoBuEwOYqCeNgs81zCx_45iq2_9ekDkMeta } from "/codebuild/output/src3388520292/src/src/pages/card/[id]/confirm-card-alias.vue?macro=true";
import { default as registerGOKc8goT_2lYsKbnwtOSp8gcm9xMWsMNnQrX_45pErLvAMeta } from "/codebuild/output/src3388520292/src/src/pages/membership/yumenavi/register.vue?macro=true";
import { default as confirm_45codeReSWZ2LEZO9N_45d65URZfOeF9d31ShmcpipILhecMqBMMeta } from "/codebuild/output/src3388520292/src/src/pages/membership/yumenavi/confirm-code.vue?macro=true";
import { default as indexcA6ChlxjevE4Hvrv_45LAVL2U_45lxo0Z1X12NRr9_4558P3kMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/email-edit/index.vue?macro=true";
import { default as indexPy5LEd41panM5CD25v0Ak3RYEHmYHwYpnJ5IEQZzwk4Meta } from "/codebuild/output/src3388520292/src/src/pages/monthly/close/[applicationId]/index.vue?macro=true";
import { default as indexY9VmUvP0chY9Xl3Lo6g4X6TfMZkRQsE32YAZrIyyiqgMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/index.vue?macro=true";
import { default as indexV0w8_45hHE6SsJaAIeRI0zN_JL6Ds9LQn_Jb_76usZ_45EEMeta } from "/codebuild/output/src3388520292/src/src/pages/monthly/cancel/[applicationId]/index.vue?macro=true";
import { default as updateVhKPsCJILITQkR5cYneq9yFvDjQpcxCesIHn68Sc_45HgMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/update.vue?macro=true";
import { default as completeom_45V_45MEkN6n33deyAhk6JM9EJJRENwB85dUIOsl9kpsMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/email-edit/complete.vue?macro=true";
import { default as confirm99GPeEVPEqITcwrWN8OxuCd5QerMK5iHhVJAJPwy9D4Meta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/confirm.vue?macro=true";
import { default as indexZVm_CdT6in1bemPOx1ezbyJBtjNVVlC9c6wNF9P8NLUMeta } from "/codebuild/output/src3388520292/src/src/pages/monthly/payments/[applicationId]/index.vue?macro=true";
import { default as completevcia8Gv12_45_45db6QedAY_F1DSCIOE2yju3t5laS0XZfgMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/complete.vue?macro=true";
import { default as updateHv2VUt1lx56ERx0sELnZkm62_FBbf1XOBDkMhPWY1n0Meta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/password-edit/update.vue?macro=true";
import { default as indexIacGpxK_45JQx3_oNSHcug05pS6lGoTtmdo_45xbnxu2FMoMeta } from "/codebuild/output/src3388520292/src/src/pages/monthly/applicant/[applicationId]/index.vue?macro=true";
import { default as indexInf8_FB0sIPpEGes4PkK6J__45UcA_FkuM5vvR_il6oQwMeta } from "/codebuild/output/src3388520292/src/src/pages/monthly/preapplication/[parkingId]/index.vue?macro=true";
import { default as completea427lmsDlW5mQoYnSA58eiPksO11iRy4_45tJtMixzdlAMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/password-edit/complete.vue?macro=true";
import { default as index5AzFpkojO42FK3CHsjVQTaPpHPBEwD0OGsdKqTlQ4n4Meta } from "/codebuild/output/src3388520292/src/src/pages/monthly/application/[applicationId]/index.vue?macro=true";
import { default as confirm_45codeO33qAIxNjVPnrT_456IhDfRD2oJb9eSOjxF6E6bcVth9kMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/email-edit/confirm-code.vue?macro=true";
import { default as indexCR4YDr_eujcOum7u2eH1z8lwBT_45ky91vj4wGXNaUQE0Meta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue?macro=true";
import { default as indexim3X35q55NO_45vPgzxVC_57Y6YvVxv1I6boY2UiFycw8Meta } from "/codebuild/output/src3388520292/src/src/pages/monthly/payments/method/[applicationId]/index.vue?macro=true";
import { default as indexLCZfBInD57VZuOG69o2sx53uYyZf_NXZziz_PhrBuZQMeta } from "/codebuild/output/src3388520292/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue?macro=true";
import { default as updateLlkaJ_45nPCvvYewGL2ndgDpzzITbnhBRaxnFmERbCrdEMeta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue?macro=true";
import { default as confirmkPqbuyJhdNB6JKstnYsTglhaMlI4ZAc1zu0TIqX6W_8Meta } from "/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue?macro=true";
export default [
  {
    name: "faq",
    path: "/faq",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/faq.vue")
  },
  {
    name: "menu",
    path: "/menu",
    meta: menuVO4kWW_45H74ILe6DYwMF1fCq63ZSjuM5vofmx6m_dyj4Meta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/menu.vue")
  },
  {
    name: "index",
    path: "/",
    meta: indexASwwtZNwnbduQYJkkm118xTyxhMdemTHDNRc4ju4DssMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/index.vue")
  },
  {
    name: "contact",
    path: "/contact",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/contact.vue")
  },
  {
    name: "tutorial",
    path: "/tutorial",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/tutorial.vue")
  },
  {
    name: "agreement",
    path: "/agreement",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/agreement.vue")
  },
  {
    name: "about-pass",
    path: "/about-pass",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/about-pass.vue")
  },
  {
    name: "card",
    path: "/card",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/card/index.vue")
  },
  {
    name: "coupon-id",
    path: "/coupon/:id()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/coupon/[id].vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/maintenance.vue")
  },
  {
    name: "notice-id",
    path: "/notice/:id()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/notice/[id].vue")
  },
  {
    name: "coupon",
    path: "/coupon",
    meta: { ...(indexEqAzTadGLAOykUOoL2lvoOeYk3hfo6TAsoD0JaFBnIIMeta || {}), ...{"middleware":["coupon-params"]} },
    component: () => import("/codebuild/output/src3388520292/src/src/pages/coupon/index.vue")
  },
  {
    name: "mypage",
    path: "/mypage",
    meta: {"middleware":"unsubscribe-store-control"},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/index.vue")
  },
  {
    name: "notice",
    path: "/notice",
    meta: {"middleware":["notice-params"]},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/notice/index.vue")
  },
  {
    name: "parking-id",
    path: "/parking/:id()",
    meta: {"middleware":["set-redirect-url","payment-step"]},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/parking/[id].vue")
  },
  {
    name: "history",
    path: "/history",
    meta: { ...(indexkdvOK3a0wPXhx3ajFJLcP7nXvuZbT0j7afhsCevZlFcMeta || {}), ...{"middleware":["payment-params"]} },
    component: () => import("/codebuild/output/src3388520292/src/src/pages/history/index.vue")
  },
  {
    name: "monthly",
    path: "/monthly",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/index.vue")
  },
  {
    name: "sign-in",
    path: "/sign-in",
    meta: index1FS1d7DOrpADJbHpA1ANTL8vQD7WpkBqSN7LO5IlQO4Meta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/sign-in/index.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    meta: indexWf9KTrLp_45qQdvz8yz9o4xythdug1hKUz9a3vkt7sGbsMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/sign-up/index.vue")
  },
  {
    name: "about-yumenavi",
    path: "/about-yumenavi",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/about-yumenavi.vue")
  },
  {
    name: "card-id-edit",
    path: "/card/:id()/edit",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/card/[id]/edit.vue")
  },
  {
    name: "pass-agreement",
    path: "/pass-agreement",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/pass-agreement.vue")
  },
  {
    name: "card-id",
    path: "/card/:id()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/card/[id]/index.vue")
  },
  {
    name: "card-confirm-3d",
    path: "/card/confirm-3d",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/card/confirm-3d.vue")
  },
  {
    name: "card-id-confirm",
    path: "/card/:id()/confirm",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/card/[id]/confirm.vue")
  },
  {
    name: "card-create",
    path: "/card/create",
    meta: indexC9jnHuejFXED3AMLSc2_45EpknMIwEORzHhSuvkIn7tooMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/card/create/index.vue")
  },
  {
    name: "mypage-pass",
    path: "/mypage/pass",
    meta: {"middleware":["pass-payment-params"]},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/pass/index.vue")
  },
  {
    name: "membership-confirm",
    path: "/membership/confirm",
    meta: confirmBSU4mYRpvN51iNeRD5Nu4efS4MIwywUPxR_45tqNdXFowMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/membership/confirm.vue")
  },
  {
    name: "card-create-confirm",
    path: "/card/create/confirm",
    meta: { ...(confirmVVrhmweNkKg_sLaschsqYiIeMsz5SeuvWG1ClpGpbTMMeta || {}), ...{"middleware":["editing-card"]} },
    component: () => import("/codebuild/output/src3388520292/src/src/pages/card/create/confirm.vue")
  },
  {
    name: "membership-complete",
    path: "/membership/complete",
    meta: completeumHSCjDNdraqdj2mfh1kkqZjp_45nEhAmO_45q1_htRjyxkMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/membership/complete.vue")
  },
  {
    name: "membership-register",
    path: "/membership/register",
    meta: registerrNQVnQywXaIBLshE0CD6FHALJjsz7x6dyu0HREY233AMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/membership/register.vue")
  },
  {
    name: "monthly-notice-id",
    path: "/monthly/notice/:id()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/notice/[id].vue")
  },
  {
    name: "contact-form-confirm",
    path: "/contact-form/confirm",
    meta: confirmSEmJnx42X4RHs5IwH3vJ1pT7V4ZdjirYVG6o5cKC4boMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/contact-form/confirm.vue")
  },
  {
    name: "history-receipt-id",
    path: "/history/receipt/:id()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/history/receipt/[id].vue")
  },
  {
    name: "monthly-notice",
    path: "/monthly/notice",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/notice/index.vue")
  },
  {
    name: "sign-in-confirm-code",
    path: "/sign-in/confirm-code",
    meta: confirm_45codeiC9zsqSQbABujBotG7DJqF1X4D4bx8uUK2bnDEVP_45ZAMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/sign-in/confirm-code.vue")
  },
  {
    name: "sign-up-confirm-code",
    path: "/sign-up/confirm-code",
    meta: confirm_45coderVcn_FkAOQTgbqDUUNFenPI4bfOyb1d_fZzH5nyn9Z0Meta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/sign-up/confirm-code.vue")
  },
  {
    name: "contact-form-complete",
    path: "/contact-form/complete",
    meta: completeyKc39F9T4wpIddYJFjugY9AQaffe52VGF2bnV6ZOLLwMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/contact-form/complete.vue")
  },
  {
    name: "contact-form-register",
    path: "/contact-form/register",
    meta: registerVOaXTBWzpPPXjJKCxXL3myyF4ciLDCub8N9t9SewWEMMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/contact-form/register.vue")
  },
  {
    name: "monthly-cancel-complete",
    path: "/monthly/cancel/complete",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/cancel/complete.vue")
  },
  {
    name: "mypage-membership",
    path: "/mypage/membership",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/index.vue")
  },
  {
    name: "mypage-sign-out-confirm",
    path: "/mypage/sign-out/confirm",
    meta: { ...(confirmFXiXgAVlip_45zHQeubdCF7h6Tg4SAWBSAp_qv1gfScYAMeta || {}), ...{"middleware":"logout-control"} },
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/sign-out/confirm.vue")
  },
  {
    name: "reset-password-complete",
    path: "/reset-password/complete",
    meta: completeP5SZVWeQyQME_45gVTDVb1ahAdATTCYN0eHJngiSKP_45MEMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/reset-password/complete.vue")
  },
  {
    name: "mypage-integration",
    path: "/mypage/integration",
    meta: { ...(indexRdJjkAz00T85fIu_45PsgsHW_SEt3oxEDwDeY9aoHBu88Meta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/integration/index.vue")
  },
  {
    name: "mypage-pass-receipt-id",
    path: "/mypage/pass/receipt/:id()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/pass/receipt/[id].vue")
  },
  {
    name: "mypage-sign-out-complete",
    path: "/mypage/sign-out/complete",
    meta: complete3v_dZnU0BYQjporp56z1v2hdBVQFArQeoYiLVInCGtIMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/sign-out/complete.vue")
  },
  {
    name: "card-id-edit-card-alias",
    path: "/card/:id()/edit-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/card/[id]/edit-card-alias.vue")
  },
  {
    name: "mypage-integration-sample",
    path: "/mypage/integration/sample",
    meta: { ...(samplehh_45rLbebG_wNhh6ZQWBbnXpX4PvnU3_45VW6_9WtiV8IwMeta || {}), ...{"middleware":["sns-integration"]} },
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/integration/sample.vue")
  },
  {
    name: "reset-password-send-email",
    path: "/reset-password/send-email",
    meta: send_45emailOEgIVM5CttP0ZgLYQ5IIS9mnnZ20Ur0paizo54D_NXkMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/reset-password/send-email.vue")
  },
  {
    name: "mypage-unsubscribe-confirm",
    path: "/mypage/unsubscribe/confirm",
    meta: { ...(confirm7xOUvSy_45tRNLhSDpQJLjW3Of1ZWiw1M4iKLI6ZOWdlcMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/unsubscribe/confirm.vue")
  },
  {
    name: "mypage-unsubscribe-consent",
    path: "/mypage/unsubscribe/consent",
    meta: { ...(consent4tO6fHJeXdlE89IxbdgzjT1Ghik9RdXRQuI0h_45lo7HAMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/unsubscribe/consent.vue")
  },
  {
    name: "membership-yumenavi-confirm",
    path: "/membership/yumenavi/confirm",
    meta: confirmwHGEbImiw5vYfS_45OpMvryaDDYSP_5J32f0gdtpGqUo0Meta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/membership/yumenavi/confirm.vue")
  },
  {
    name: "monthly-application-duedate",
    path: "/monthly/application/duedate",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/application/duedate.vue")
  },
  {
    name: "mypage-unsubscribe-complete",
    path: "/mypage/unsubscribe/complete",
    meta: { ...(completef790eROUG81Q6vlo3tZE_45O_Rx_K7qpgiEfBfYgjJ_45UwMeta || {}), ...{"middleware":"unsubscribe-store-control"} },
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/unsubscribe/complete.vue")
  },
  {
    name: "reset-password-confirm-code",
    path: "/reset-password/confirm-code",
    meta: confirm_45codeDCRSC2xa6nZM6flUckp2JlXyQZUyn2KoDUSbqjcFpM8Meta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/reset-password/confirm-code.vue")
  },
  {
    name: "reset-password-new-password",
    path: "/reset-password/new-password",
    meta: new_45password8jPivJCXqB1Z9BgTH8Jzv8rrAMLnLWZpw6ciofJyoQUMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/reset-password/new-password.vue")
  },
  {
    name: "card-id-confirm-card-alias",
    path: "/card/:id()/confirm-card-alias",
    meta: {"middleware":["editing-card"]},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/card/[id]/confirm-card-alias.vue")
  },
  {
    name: "membership-yumenavi-register",
    path: "/membership/yumenavi/register",
    meta: registerGOKc8goT_2lYsKbnwtOSp8gcm9xMWsMNnQrX_45pErLvAMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/membership/yumenavi/register.vue")
  },
  {
    name: "membership-yumenavi-confirm-code",
    path: "/membership/yumenavi/confirm-code",
    meta: confirm_45codeReSWZ2LEZO9N_45d65URZfOeF9d31ShmcpipILhecMqBMMeta || {},
    component: () => import("/codebuild/output/src3388520292/src/src/pages/membership/yumenavi/confirm-code.vue")
  },
  {
    name: "mypage-membership-email-edit",
    path: "/mypage/membership/email-edit",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/email-edit/index.vue")
  },
  {
    name: "monthly-close-applicationId",
    path: "/monthly/close/:applicationId()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/close/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit",
    path: "/mypage/membership/others-edit",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/index.vue")
  },
  {
    name: "monthly-cancel-applicationId",
    path: "/monthly/cancel/:applicationId()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/cancel/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-update",
    path: "/mypage/membership/others-edit/update",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/update.vue")
  },
  {
    name: "mypage-membership-email-edit-complete",
    path: "/mypage/membership/email-edit/complete",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/email-edit/complete.vue")
  },
  {
    name: "mypage-membership-others-edit-confirm",
    path: "/mypage/membership/others-edit/confirm",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/confirm.vue")
  },
  {
    name: "monthly-payments-applicationId",
    path: "/monthly/payments/:applicationId()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/payments/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-complete",
    path: "/mypage/membership/others-edit/complete",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/complete.vue")
  },
  {
    name: "mypage-membership-password-edit-update",
    path: "/mypage/membership/password-edit/update",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/password-edit/update.vue")
  },
  {
    name: "monthly-applicant-applicationId",
    path: "/monthly/applicant/:applicationId()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/applicant/[applicationId]/index.vue")
  },
  {
    name: "monthly-preapplication-parkingId",
    path: "/monthly/preapplication/:parkingId()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/preapplication/[parkingId]/index.vue")
  },
  {
    name: "mypage-membership-password-edit-complete",
    path: "/mypage/membership/password-edit/complete",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/password-edit/complete.vue")
  },
  {
    name: "monthly-application-applicationId",
    path: "/monthly/application/:applicationId()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/application/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-email-edit-confirm-code",
    path: "/mypage/membership/email-edit/confirm-code",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/email-edit/confirm-code.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi",
    path: "/mypage/membership/others-edit/yumenavi",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/yumenavi/index.vue")
  },
  {
    name: "monthly-payments-method-applicationId",
    path: "/monthly/payments/method/:applicationId()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/payments/method/[applicationId]/index.vue")
  },
  {
    name: "monthly-renewalcontract-applicationId",
    path: "/monthly/renewalcontract/:applicationId()",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/monthly/renewalcontract/[applicationId]/index.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-update",
    path: "/mypage/membership/others-edit/yumenavi/update",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/yumenavi/update.vue")
  },
  {
    name: "mypage-membership-others-edit-yumenavi-confirm",
    path: "/mypage/membership/others-edit/yumenavi/confirm",
    component: () => import("/codebuild/output/src3388520292/src/src/pages/mypage/membership/others-edit/yumenavi/confirm.vue")
  }
]